import axios from 'axios';
// import Cookies from 'js-cookie';
import { Loading, Message } from 'element-ui';
import router from '@/router';
import config from './config.base';
import LOGIN_TOKEN, { getToken, rmToken, setToken } from './storge';

const token = getToken(LOGIN_TOKEN);
/* eslint-disable */
const instance = axios.create({
  headers: { 'content-type': 'application/json' },
  headers: { Authorization:`Bearer ${token}` },
});

instance.defaults.baseURL = config.baseURL;
instance.defaults.withCredentials = true;
let loadingInstance;
// 添加请求拦截器
instance.interceptors.request.use((config) => {
  const token = getToken(LOGIN_TOKEN);
  loadingInstance = Loading.service({ fullscreen: true });
  // 在发送请求之前做些什么
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => {
    loadingInstance.close();
  // 对请求错误做些什么
  Promise.reject(error);
});

let isTip = false;
// 添加响应拦截器
instance.interceptors.response.use((response) => {
  loadingInstance.close();
  const { data } = response || {};
  if (data.code == 1) {
    isTip = false;
  }
  if (data.code == 0 && (data.msg == 'token过期' || data.msg == 'token无效')) {
    rmToken();
    router.push({ path: '/login' });
    isTip = true;
  } else if (data.code == -2) {
    rmToken();
    if (!isTip && data.msg) {
    Message({message: data.msg, type: 'error'})
    }
    router.push({ path: '/login' });
    
    isTip = true;
  } else {
    if ('authorization' in response.headers){
      console.info("update token");
      setToken(response.headers['authorization'].substring(7));
    }
  }
  if (!isTip && data) {
    return data;
  }
}, (error) => {
  loadingInstance.close();
  if (!isTip && error.message) {
  Message({message: error.message, type: 'error'})
  return Promise.reject(error);
  }
});

export default instance;
